export default {
    api: 'https://api.martendenheijer.nl/data-service/v4'
}



// WEBPACK FOOTER //
// ./src/config/index.js